module.exports = __webpack_public_path__ + "static/img/son1_active.6d045727.png";